import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import { toggleNPercentRiyal } from "Constants/Constants";
import { FACTOR_RESULT } from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";

export default function SettingsCost({ onChange, DefaultCost }) {
  const { factorResult } = useSelector((state) => ({
    factorResult: state.factor.factorResult,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    CostJanebi: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "IsPercentCostJanebi",
      label: "otherCost",
    },
    IsPercentCostJanebi: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "CostJanebi",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    CostMasrafi: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "IsPercentCostMasrafi",
      label: "consumedMaterialCost",
    },
    IsPercentCostMasrafi: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "CostMasrafi",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    CostNasb: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "IsPercentCostNasb",
      label: "installationCost",
    },
    IsPercentCostNasb: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "CostNasb",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
      ValidationPlus: {
        isPercent: true,
      },
    },
    CostArc: {
      type: "price",
      value: 0,
      box: 2,
      label: "arc",
      validation: {
        required: true,
        isPrice: true,
      },
    },
    CostAngle: {
      type: "price",
      value: 0,
      box: 2,
      label: "angles",
      validation: {
        required: true,
        isPrice: true,
      },
    },
    PriceTransfer: {
      type: "price",
      value: 0,
      box: 2,
      label: "shippingCost",
      validation: {
        required: true,
        isPrice: true,
      },
    },
    Tax: {
      type: "percent",
      value: 0,
      box: 2,
      label: "maliyat",
      validation: {
        isPercent: true,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    if (validation) {
      const result = {
        ...factorResult,
        [name]: +value,
      };
      dispatch({ type: FACTOR_RESULT, factorResult: result });
    }
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ [controls[name].relation]: { value: 0 } });
    const result = {
      ...factorResult,
      [name]: value.value,
      [controls[name].relation]: 0,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  };

  useEffect(() => {
    if (factorResult.CostJanebi)
      setControls({ CostJanebi: { value: factorResult.CostJanebi } });
    if (factorResult.CostMasrafi)
      setControls({ CostMasrafi: { value: factorResult.CostMasrafi } });
    if (factorResult.CostNasb)
      setControls({ CostNasb: { value: factorResult.CostNasb } });
    setControls({
      IsPercentCostJanebi: {
        value: factorResult?.IsPercentCostJanebi
          ? toggleNPercentRiyal[0]
          : toggleNPercentRiyal[1],
      },
    });
    setControls({
      IsPercentCostMasrafi: {
        value: factorResult?.IsPercentCostMasrafi
          ? toggleNPercentRiyal[0]
          : toggleNPercentRiyal[1],
      },
    });
    setControls({
      IsPercentCostNasb: {
        value: factorResult?.IsPercentCostNasb
          ? toggleNPercentRiyal[0]
          : toggleNPercentRiyal[1],
      },
    });
    if (factorResult.CostArc)
      setControls({ CostArc: { value: factorResult.CostArc } });
    if (factorResult.CostAngle)
      setControls({ CostAngle: { value: factorResult.CostAngle } });
    if (factorResult.PriceTransfer)
      setControls({ PriceTransfer: { value: factorResult.PriceTransfer } });
    if (factorResult.Tax) setControls({ Tax: { value: factorResult.Tax } });
  }, []);

  return (
    <Grid container className="p-2">
      <Grid item xs={12} md={6} className="p-2">
        <Grid container className="box-re-border p-2">
          {Object.keys(controls)
            .filter((key) => controls[key].box === 1)
            .map((key, index) => {
              return (
                <Grid item xs={12} key={key + index}>
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls[key].value}
                    name={key}
                    validation={
                      controls[key].relation &&
                      controls[controls[key].relation].value.value
                        ? {
                            ...controls[key].validation,
                            ...controls[controls[key].relation].ValidationPlus,
                          }
                        : controls[key].validation
                    }
                    label={<Translator id={controls[key].label} />}
                    type={controls[key].type}
                    endIcon={
                      controls[controls[key].relation].value.value ? (
                        "%"
                      ) : (
                        <Translator id={"moneyUnit"} />
                      )
                    }
                    radioGroup={{
                      name: controls[key].relation,
                      value: controls[controls[key].relation].value,
                      items: controls[controls[key].relation].arrayItems,
                      onChange: onChangeToggle,
                    }}
                  />
                </Grid>
              );
            })}
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} className="p-2">
        <Grid container className="box-re-border p-2">
          {Object.keys(controls)
            .filter((key) => controls[key].box === 2)
            .map((key, index) => {
              return (
                <Grid item xs={12} key={key + index}>
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls[key].value}
                    name={key}
                    validation={controls[key].validation}
                    label={<Translator id={controls[key].label} />}
                    type={controls[key].type}
                    endIcon={
                      controls[key].type === "percent" ? (
                        "%"
                      ) : (
                        <Translator id={"moneyUnit"} />
                      )
                    }
                  />
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </Grid>
  );
}
